import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import '../node_modules/@fortawesome/fontawesome-free/css/all.css';
import '../node_modules/font-awesome/css/font-awesome.min.css';
import "react-datepicker/dist/react-datepicker.css";
import '../node_modules/webfont-medical-icons/css/webfont-medical-icons.css';
// import ReactGA from 'react-ga';
import ReactGA from "react-ga4";
import { userService } from './services/user';

/* Sentry */
Sentry.init({
  dsn: "https://823a3863d9e24785b904f9c41f834194@o1069318.ingest.sentry.io/6158357",
  integrations: [new Integrations.BrowserTracing()],
  environment:  process.env.REACT_APP_SENTRY_ENVIRONMENT,
  enabled:      process.env.REACT_APP_SENTRY_ENVIRONMENT !== 'development',

  initialScope: {
    user: userService.getCurrentUserSentryParams()
  },

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.0
});

/* Facebook */
window.fbAsyncInit = function() {
  window.FB.init({
      appId      : process.env.REACT_APP_FACEBOOK_APP_ID,
      cookie     : true,  // enable cookies to allow the server to access the session
      xfbml      : false,  // parse social plugins on this page
      autoLogAppEvents : true,
      version    : 'v22.0'
  });
};
(function(d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s); js.id = id;
    js.src = "//connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));

/* Google Analytics  */
const trackingId = process.env.REACT_APP_GOOGLE_TRACKING_ID; // Replace with your Google Analytics tracking ID
ReactGA.initialize(trackingId);
// ReactGA.pageview(window.location.pathname);
ReactGA.send({ hitType: "pageview", page: window.location.pathname });

ReactDOM.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>, document.getElementById('root'));
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals


reportWebVitals();